module.exports = __webpack_public_path__ + "img/bg-planprice-light.0fa35de9.png";